import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as EditorActions from '../../../actions/editor';
import { SIDEPANE } from '../../../constants';
import ConfigEditorHeader from '../../config-editor/config-editor-header';
import './index.css';
class SpecEditorHeader extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: "editor-header spec-editor-header" },
            React.createElement("ul", { className: "tabs-nav" },
                React.createElement("li", { className: this.props.sidePaneItem === SIDEPANE.Editor ? 'active-tab' : undefined, onClick: (e) => {
                        if (this.props.sidePaneItem === SIDEPANE.Editor) {
                            e.stopPropagation();
                        }
                        e.stopPropagation();
                        this.props.setSidePaneItem(SIDEPANE.Editor);
                    } }, this.props.mode),
                React.createElement("li", { className: this.props.sidePaneItem === SIDEPANE.Config ? 'active-tab' : undefined, onClick: (e) => {
                        if (this.props.sidePaneItem === SIDEPANE.Config) {
                            e.stopPropagation();
                        }
                        e.stopPropagation();
                        this.props.setSidePaneItem(SIDEPANE.Config);
                    } }, "Config")),
            this.props.sidePaneItem === SIDEPANE.Config && React.createElement(ConfigEditorHeader, null)));
    }
}
function mapStateToProps(state) {
    return {
        compiledVegaSpec: state.compiledVegaSpec,
        configEditorString: state.configEditorString,
        editorString: state.editorString,
        manualParse: state.manualParse,
        mode: state.mode,
        sidePaneItem: state.sidePaneItem,
        themeName: state.themeName,
        value: state.vegaSpec,
    };
}
export function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setSidePaneItem: EditorActions.setSidePaneItem,
    }, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SpecEditorHeader));
